import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-81d61790"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-path" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-folder-opened",
  style: {"position":"absolute","font-size":"16px","top":"6px","right":"10px","color":"var(--cm-color-text-secondary)"}
}, null, -1))

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import { computed, h, onMounted, reactive, ref } from 'vue'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { systemAuthService } from '@/common/basis/root-injector'
import { AuthInfo } from '@/services/system-auth.service'
import { AuthorizeInfoService } from '@/views/authorize/authorize-info.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormSizeType } from '@/components/cmForm/types'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'authorize-info',
  props: {
  flag: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props
const injector = useReflectiveInjector([AuthorizeInfoService])
const authorizeInfoService = injector.get(AuthorizeInfoService)
const { t, locale } = useI18n()
const formType = FormActionType.Other
const formSize: FormSizeType = FormSize.Small
const uploadNode = ref()
const viewModel = reactive({
  errorMsg: '',
  fileName: '',
  file: null,
})
const form = ref({} as { deploy_ip: string, deploy_port: string })

const validateIp = (rule: any, value: string, callback: Function) => {
  if (value && value.includes(':')) {
    callback(new Error(t('authorizePage.ipCannotContainPort')))
  } else {
    callback()
  }
}

const formColumns = computed(() => {
  locale.value
  return {
    deploy_ip: {
      modelModifiers: { trim: true },
      label: t('authorizePage.serverIp'),
      colOpt: { span: props.flag ? 5 : 10 },
      required: true,
      rules: [{ custom: { validator: validateIp } }]
    },
    deploy_port: {
      modelModifiers: { trim: true },
      label: t('authorizePage.serverPort'),
      colOpt: { span: props.flag ? 5 : 10 },
      required: true
    },
    file: {
      label: t('authorizePage.uploadAuthFile'), slot: true, colOpt: { span: props.flag ? 14 : 24 }
    },
  }
})
const handleClick = () => {
  uploadNode.value.clearFiles()
  viewModel.fileName = ''
}
const authFail = (msg: string) => {
  ElMessageBox({
    title: t('authorizePage.authDialogTitle'),
    customClass: 'cm-ui-message-box',
    message: h('div', { style: 'display:flex;align-items:center;margin-left:5px;margin-top:25px;margin-bottom:40px' }, [
      h('div', { style: 'display: flex; align-items:center; justify-content: center' }, [
        h(CmSvgIcon, {
          size: 70,
          monochrome: true,
          color:"var(--el-color-primary)",
          name: 'views/authorize/_images/tips',
        }),
        h('div', { style: 'display: flex; flex-direction: column;margin-left:10px;' }, [
          h('p', { style: 'font-size: 16px; font-weight: 600; color: var(--cm-color-text-primary);' }, t('authorizePage.authVerifyFailedTitle')),
          h('p', { style: 'margin-top: 10px; font-size: 14px; color: var(--cm-color-text-secondary);' }, msg)
        ])
      ])
    ]),
    confirmButtonText: t('common.confirm')
  })
}
function parseServerAddress (serverAddress?: string) {
  // 没有serverAddress时，认为是初始化授权，给默认端口10082
  if (!serverAddress) {
    return { ip: '', port: '10082' }
  }
  const parts = serverAddress.split(':')
  if (parts.length === 2) {
    return { ip: parts[0], port: parts[1] }
  }
  return { ip: serverAddress, port: '' }
}

const handleSubmitUpload = () => {
  if (!form.value.deploy_ip || !form.value.deploy_port) return;
  uploadNode.value.submit()
}
const handleHttpUpload = () => {
  const formData = new FormData()
  formData.append('file', viewModel.file)
  const deployIp = `${form.value.deploy_ip}:${form.value.deploy_port}`
  formData.append('deploy_ip', deployIp)
  authorizeInfoService.fileUpload(formData).then((res) => {
    if (res.resp_common.ret === 0) {
      ElMessage.success(t('authorizePage.authVerifySuccess'))
      systemAuthService.updateRemoteAuthInfo()
    } else {
      authFail(t('cmformExtra.uploadFailed'))
    }
  }).catch(() => {
    authFail(t('cmformExtra.uploadFailed'))
  }).finally(() => {
    uploadNode.value?.clearFiles()
    viewModel.fileName = ''
  })
}
const handleChange = (file: any, list: []) => {
  if (file?.status === 'ready') {
    viewModel.file = file.raw
    viewModel.fileName = file.name
  }
}
onMounted(() => {
  systemAuthService.updateAuthInfoEvent.subscribe((info) => {
    // 后端返回的是"ip:port"格式，需要拆分
    const { ip, port } = parseServerAddress(info.deploy_ip)
    form.value.deploy_ip = ip
    form.value.deploy_port = port
  })
  systemAuthService.updateRemoteAuthInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(CmForm, {
    formSize: _unref(formSize),
    formType: _unref(formType),
    "onUpdate:formType": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formType) ? (formType).value = $event : null)),
    rowOpt: { gutter: 10 },
    formOpt: { 'label-position': 'top' },
    modelValue: form.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form).value = $event)),
    ref: "formRef",
    formColumns: formColumns.value
  }, {
    file: _withCtx(() => [
      _createVNode(_component_el_row, { style: {"flex":"1"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            style: {"position":"relative","width":"100%","flex":"1 1 0%","box-sizing":"border-box"},
            class: "upload-col el-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                ref_key: "uploadNode",
                ref: uploadNode,
                class: "cm-upload",
                accept: ".key",
                style: {"position":"absolute","left":"0","right":"0","top":"0","z-index":"10000"},
                name: "file",
                limit: 1,
                "show-file-list": false,
                "auto-upload": false,
                "on-change": handleChange,
                "http-request": handleHttpUpload,
                onClick: handleClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(viewModel.fileName || _unref(t)('authorizePage.contactForAuthFile')), 1),
                  _hoisted_2
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "cm-ui-ml10",
            size: "small",
            type: "primary",
            onClick: handleSubmitUpload,
            disabled: viewModel.fileName === '' || !form.value.deploy_ip || !form.value.deploy_port
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('authorizePage.updateAuth')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["formSize", "formType", "modelValue", "formColumns"]))
}
}

})